import { Col, ColorPicker, Form, Modal, Row, Select } from "antd";
import { useEffect } from "react";

/**
 *
 * @param {{ isEdgeModalOpen: boolean; selectedEdge: {}; handleEdgeCancel: () => void; handleEdgeOk: (value) => void; }} param0
 * @param {boolean} [param0.isEdgeModalOpen] the param for this input. if POST is body, GET is query params.
 * @param {{}} [param0.selectedEdge] the content type for this fetch.
 * @param {() => void} [param0.handleEdgeCancel=() => { }] function called when fetch called success with OK response
 * @param {(value) => void} [param0.handleEdgeOk=(value) => { }] function called when fetch called success but with not OK response
 * @returns
 */
export default function EdgeEditingModal({
  isEdgeModalOpen,
  selectedEdge,
  handleEdgeCancel = () => {},
  handleEdgeOk = (value) => {},
}) {
  const [form] = Form.useForm();

  function onOk() {
    handleEdgeOk(form.getFieldsValue(true));
  }

  useEffect(() => {
    form.setFieldsValue({
      "line/stroke": selectedEdge?.getAttrByPath("line/stroke"),
      "line/strokeDasharray": selectedEdge?.getAttrByPath(
        "line/strokeDasharray"
      ),
      "line/sourceMarker/width":
        selectedEdge?.getAttrByPath("line/sourceMarker/width") ?? 1,
      "line/targetMarker/width":
        selectedEdge?.getAttrByPath("line/targetMarker/width") ?? 1,
      "line/style/animation": selectedEdge?.getAttrByPath(
        "line/style/animation"
      ),
    });
  }, [selectedEdge]);

  return (
    <Modal
      title="Configure Edge"
      open={isEdgeModalOpen}
      onOk={onOk}
      onCancel={handleEdgeCancel}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Line Color"
          name="line/stroke"
          getValueFromEvent={(color) => {
            if (color.toHex() == "000000") {
              return "var(--ant-color-text-base)";
            }
            return "#" + color.toHex();
          }}
        >
          <ColorPicker format={"hex"} showText></ColorPicker>
        </Form.Item>
        <Form.Item label="Line Type" name="line/strokeDasharray">
          <Select>
            <Select.Option value={0} label="Solid">
              Solid
            </Select.Option>
            <Select.Option value={2} label="Dotted">
              Dotted
            </Select.Option>
            <Select.Option value={5} label="Dashed">
              Dashed
            </Select.Option>
          </Select>
        </Form.Item>
        <Row gutter={[24, 12]}>
          <Col span={12}>
            <Form.Item label="Source Marker" name="line/sourceMarker/width">
              <Select
                onChange={(value) => {
                  form.setFieldValue("line/sourceMarker/height", value);
                }}
              >
                <Select.Option value={1} label="None">
                  None
                </Select.Option>
                <Select.Option value={8} label="Small">
                  Small
                </Select.Option>
                <Select.Option value={12} label="Medium">
                  Medium
                </Select.Option>
                <Select.Option value={16} label="Large">
                  Large
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Target Marker" name="line/targetMarker/width">
              <Select
                onChange={(value) => {
                  form.setFieldValue("line/targetMarker/height", value);
                }}
              >
                <Select.Option value={1} label="None">
                  None
                </Select.Option>
                <Select.Option value={8} label="Small">
                  Small
                </Select.Option>
                <Select.Option value={12} label="Medium">
                  Medium
                </Select.Option>
                <Select.Option value={16} label="Large">
                  Large
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Animation" name="line/style/animation">
          <Select>
            <Select.Option value={""} label="No">
              No
            </Select.Option>
            <Select.Option value={"ant-line 30s infinite linear"} label="Yes">
              Yes
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
